<!-- NavCap (shown if item has no parent) -->
<!-- @if (depth === 0 && item.navCap && !item.parentSideMenuId) {
  <div mat-subheader class="nav-caption" style="font-size:14px;">
    {{langCode =='en'? item.nameEn :item.nameAr}}
  </div>
} -->


<!-- Normal Menu Item (Internal Route) -->
@if (!item.external || item.children?.length) {
<a mat-list-item (click)="onItemSelected(item)" [ngClass]="{
    'mat-toolbar mat-primary activeMenu': item.route
      ? router.isActive(item.route, true)
      : false,
    expanded: expanded,
    disabled: item.disabled,
    'level-0': depth === 0,
    'level-1': depth === 1,
    'level-2': depth >= 2,
    'pinned-item': isPinned
  }" class="menu-list-item {{ item.bgcolor }}">

  <i-tabler class="routeIcon" name="{{ item.iconName }}" matListItemIcon></i-tabler>

  <span class="hide-menu">{{langCode =='en'? item.nameEn :item.nameAr }}</span>

  <!-- Expand arrow -->
  @if (item.children?.length) {
  <span class="arrow-icon" fxFlex>
    <span fxFlex></span>
    <mat-icon [@indicatorRotate]="expanded ? 'expanded' : 'collapsed'">
      expand_more
    </mat-icon>
  </span>
  }

  <!-- Chip -->
  @if (item.chipContent) {
  <span>
    <span class="{{ item.chipClass }} p-x-8 p-y-4 item-chip f-w-500 rounded-pill ">
      {{ item.chipContent }}
    </span>
  </span>
  }
  <!-- Pin Button -->
  @if (shouldShowPinButton()) {
  <div class="pin-container" [class.pinned]="isPinned" (click)="togglePin($event)">
    <svg *ngIf="!isPinned" class="pin-svg" viewBox="0 0 24 24" fill="none" stroke="currentColor">
      <path d="M16,12V4H17V2H7V4H8V12L6,14V16H11.2V22H12.8V16H18V14L16,12Z" />
    </svg>
    <svg *ngIf="isPinned" class="pin-svg pinned-svg" viewBox="0 0 24 24" fill="currentColor">
      <path d="M16,12V4H17V2H7V4H8V12L6,14V16H11.2V22H12.8V16H18V14L16,12Z" />
    </svg>
  </div>
  }
</a>}

<!-- External Link -->
<!-- @if (item.external) {
  <mat-list-item
    (click)="window.open(item.route, '_blank')"
    class="menu-list-item {{ item.bgcolor }}"
    target="_blank"
  >
    <i-tabler
      class="routeIcon"
      name="{{ item.iconName }}"
      matListItemIcon
    ></i-tabler>
    <span class="hide-menu">{{ item.nameEn }}</span>
  </mat-list-item>
} -->

<!-- Children -->
@if (item.children?.length && expanded) {
@for (child of item.children; track child.id) {
<app-nav-item [item]="child" [depth]="depth + 1" (click)="onSubItemSelected(child)"></app-nav-item>
}

}